import { useMemo } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import LinkUtil from "../../utils/LinkUtil";
import { otherInfoContactNumber } from "./constants";
import "./style.css";
import "../diwali2022/style.css";
import TermsAndCondition from "./TermsAndCondition";
import useDiwaliHook from "./useDiwaliHook";

const RetailersContainer = () => {
  const { homepageData, carouselData, trackEvent, lang }:any = useDiwaliHook();

  const handleTracking = (event: any, attributes: any, newSourcePage?:any) => {
    trackEvent(event, attributes, newSourcePage)
  }

  const phone = useMemo(() => <span onClick={() => LinkUtil.phone(otherInfoContactNumber)}>{otherInfoContactNumber}</span>, []);
  const otherInfoCallHi = useMemo(
    () => (
      <>
        अधिक जानकारी के लिए Just सेल्स टीम से संपर्क करें, हमें {phone} पर कॉल करें या Just Retailer ऐप चेक करें।
      </>
    ),
    [phone]
  );
  const otherInfoCall = useMemo(
    () => (
      <>
        अधिक जानकारी के लिए Just सेल्स टीम से संपर्क करें, हमें {phone} पर कॉल
        करें या Just Retailer ऐप चेक करें।
      </>
    ),
    [phone]
  );
  
  return (
    <div className="main_container_retailers_contest">
      <h1 className="diwali_dhamaka_container">
        <img
          src={homepageData?.diwaliDhamakaImg}
          alt="diwali-dhamaka"
          className="diwali_dhamaka"
        />
      </h1>
      {Object.keys(carouselData || {})?.length > 0 && (
        <Carousel
          infiniteLoop
          showThumbs={false}
          swipeable
          autoPlay
          interval={3000}
          showArrows={false}
          centerMode
          centerSlidePercentage={60}
          selectedItem={0}
          showStatus={false}
          showIndicators={false}
        >
          {Object.keys(carouselData || {}).map((key: any, index) => {
            return (
              <div key={index}>
                <img src={carouselData?.[key]} alt={`carasoul_img_${index}`} />
              </div>
            );
          })}
        </Carousel>
      )}
      <div className="winner_container">
        <div className="flex_space_between">
          <div className="flex_space_between">
            <h3 className="section_heading">
              {" "}
              {homepageData?.homepageWinnerHeadingOne}{" "}
            </h3>
            <img
              src={homepageData?.diwaliBlast}
              alt="diwali-blast"
              className="diwali_blast"
            />
          </div>
          <Link
            to={{ pathname: "/retailers-contest/winners/1/" }}
            className="see_all_btn"
            onClick={() =>
              handleTracking("cta_sabji_ka_raja", { event_type: "click" })
            }
          >
            <p>See all</p>
          </Link>
        </div>
        <Link
          to={{ pathname: "/retailers-contest/winners/1" }}
          onClick={() =>
            handleTracking("cta_daily_lucky_winners", { event_type: "click" })
          }
        >
          <img
            className="daily_winner_banner"
            src={homepageData?.dailyWinner}
            alt="daily_winner"
          />
        </Link>
      </div>

      <div className="winner_container">
        <div className="flex_space_between">
          <div className="flex_space_between">
            <h3 className="section_heading">
              {" "}
              {homepageData?.homepageWinnerHeadingTwo}{" "}
            </h3>
            <img
              src={homepageData?.diwaliBlast}
              alt="diwali-blast"
              className="diwali_blast"
            />
          </div>
          <Link
            to={{ pathname: "/retailers-contest/winners/2" }}
            className="see_all_btn"
            onClick={() =>
              handleTracking("cta_aaj_ka_khiladi", { event_type: "click" })
            }
          >
            <p>See all</p>
          </Link>
        </div>
        <Link
          to={{ pathname: "/retailers-contest/winners/2" }}
          onClick={() =>
            handleTracking("cta_aaj_ka_khiladi", { event_type: "click" })
          }
        >
          <img
            className="daily_winner_banner"
            src={homepageData?.dailyWinnerInactive}
            alt="daily_winner"
          />
        </Link>
      </div>

      <TermsAndCondition src={homepageData?.termsAndConditions} />
      <div className="diwali-more-info-contact">
        <p style={{
          padding: '0 20px',
          textAlign: 'center'
        }}>{lang === "hi" ? otherInfoCallHi : otherInfoCall}</p>
      </div>
    </div>
  );
};

export default RetailersContainer;
